export default __webpack_public_path__ + "static/media/saiteja_bhoomraogari.bf78fba8.png";